import { mapValues } from 'lodash';
/**
 * Version 18 migrations registration summary widget
 * - Adding default style for action links on the attendee name header
 */

const summaryHeaderActionLinksStyle = {
  styleMapping: 'link',
  customSettings: {
    spacing: {
      padding: {
        paddingTop: 0,
        paddingRight: 10,
        paddingBottom: 0,
        paddingLeft: 0
      }
    }
  }
};

export default function v18(website) {
  return {
    ...website,
    eventVersion: 18,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.style.summaryHeaderActionLinks) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              summaryHeaderActionLinks: { ...summaryHeaderActionLinksStyle }
            }
          }
        };
      }
      if (layoutItem.widgetType === 'GuestRegistration' && !layoutItem.config.configGuestProductSelectionDisabled) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            configGuestProductSelectionDisabled: true
          }
        };
      }
      return layoutItem;
    })
  };
}
